import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { MobileLoaderLayout } from 'modules/Layout';
// This route is used for communication with the mobile version of the application eg. CDA (alpine),
// which displays specific processes in a WebView.
// The mobile application is responsible for intercepting the redirection to this route,
// processing additional data such as an auth code, and subsequently closing the WebView.
// This ensures a seamless transition from the WebView back to the native application flow.
function action({ route }) {
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        component: /*#__PURE__*/ _jsx(MobileLoaderLayout, {})
    };
}
export default action;
